module.exports = __webpack_public_path__ + "img/website.a2ad7a4e.png";